// extracted by mini-css-extract-plugin
export default {"menu_item":"DropDownMenuItem_menu_item__oNajH"};